<template>
  <div>
    <el-dialog :visible.sync="showmodal" width="35%" @close="$emit('close-modal')">
      <div class="text-center modals-wrapper">
        <img src="../../../../../assets/images/icons/putonhold-modal-icon.png" class="mt-20 mx-auto">
        <p class="mt-10 text-md">Are you sure you want to cancel this Shipment?</p>

        <button v-loading="loading" @click="cancelShipment" class="mt-12 rounded-md p-3 px-4 text-md">Yes,
          Cancel</button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { userId } from "@/services/apiConfig.js";

export default {
  props: {
    dispatch: {},
    showmodal: {
      type: Boolean,
      required: true,
    }
  },
  data() {
    return {
      loading: false,
    };
  },
  methods: {
    async cancelShipment() {

      try {
         console.log("Dispatch to cancel", this.dispatch)
        this.loading = true
        await this.$_newCancelDispatch(this.dispatch?.id, {
          message: "I dont want to proceed",
          userId: userId()
        })
        this.loading = false

        this.$emit('refetch-dispatch')
        this.$emit('close-modal')
      } catch (error) {
        this.loading = false
        this.handleError(error)
      }


    },
  },
};
</script>

<style lang="scss" scoped>
.button {
  background: #fcc210;
  color: var(--primaryblue);
  width: 40%;
  font-weight: 500;
  /* margin-top: 3rem; */
}

.new-address-button {
  text-decoration-line: underline;

  color: #da9601;
}

.radio-label span::after {
  background: #bec4d5;
}

.modals-wrapper {
  button {
    background-color: #FCC210;
    color: #10233E;
    font-weight: 600;
  }

  input {}
}
</style>
